import React, { createContext, useContext, useState } from 'react';

import {getBackUrl} from '../../utils';

const BackUrlContext = createContext();

const BackUrlProvider = ({ children }) => {
  const [backUrl, setBackUrl] = useState(getBackUrl);

  return <BackUrlContext.Provider value={{ backUrl, setBackUrl }}>{children}</BackUrlContext.Provider>;
};

/**
 * @returns {string}
 */
const useBackUrl = () => useContext(BackUrlContext);

export { BackUrlProvider, useBackUrl };
